/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ stage: NonNullable<unknown> }} Directory_Submit_Enrich_Failed_AtInputs */

const en_directory_submit_enrich_failed_at = /** @type {(inputs: Directory_Submit_Enrich_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed at: ${i?.stage}`)
};

const zh_directory_submit_enrich_failed_at = /** @type {(inputs: Directory_Submit_Enrich_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`失败模块：${i?.stage}`)
};

/**
* | output |
* | --- |
* | "Failed at: {stage}" |
*
* @param {Directory_Submit_Enrich_Failed_AtInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_failed_at = /** @type {((inputs: Directory_Submit_Enrich_Failed_AtInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Failed_AtInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_failed_at(inputs)
	return zh_directory_submit_enrich_failed_at(inputs)
});
export { directory_submit_enrich_failed_at as "directory.submit.enrich.failed_at" }